import { TOPBAR_HEIGHT } from '@capsicum/common-web';
import { useEffect, useMemo, useState } from 'react';

export type UseWCPledgeScrollProps = {
	headerWarningHeight: number;
	isUkHeaderWarningDisplayed: boolean;
	titleHeight: number;
};

export const useWCPledgeScroll = ({
	headerWarningHeight,
	isUkHeaderWarningDisplayed,
	titleHeight
}: UseWCPledgeScrollProps) => {
	const topBarTransparentBreakpoint = TOPBAR_HEIGHT;
	const tabBarTransparentBreakpoint = isUkHeaderWarningDisplayed ? titleHeight + headerWarningHeight : titleHeight;

	const [isTopBarTransparent, setIsTopBarTransparent] = useState(window.scrollY < topBarTransparentBreakpoint);
	const [isTabBarTransparent, setIsTabBarTransparent] = useState(window.scrollY < tabBarTransparentBreakpoint);

	const stickyOffsetTop = useMemo(() => {
		return isUkHeaderWarningDisplayed ? headerWarningHeight + TOPBAR_HEIGHT : TOPBAR_HEIGHT;
	}, [isUkHeaderWarningDisplayed]);

	const handleScroll = () => {
		setIsTopBarTransparent(window.scrollY < topBarTransparentBreakpoint);
		setIsTabBarTransparent(window.scrollY < tabBarTransparentBreakpoint);
	};

	useEffect(() => {
		window.addEventListener('scroll', handleScroll);

		return () => {
			window.removeEventListener('scroll', handleScroll);
		};
	}, []);

	return { isTabBarTransparent, isTopBarTransparent, stickyOffsetTop };
};
